import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { getSelectedInstances } from '../../../redux/providerBuilder/selectedInstances/selectors';
import {
  getSelectedNetworkIndex,
  getSelectedNetworkRequest,
} from '../../../redux/providerBuilder/selectedNetworkRequest/selectors';
import { IntegrationDetails } from '../../integration-details/integration-details.screen';
import { updateAppDetails } from '../../../redux/appBuilder/appDetails';
import { getAppDetails } from '../../../redux/appBuilder/appDetails/selectors';

const ZkfetchFinlize = () => {
  const selectedInstances = useAppSelector(getSelectedInstances);
  const selectedNetworkRequest = useAppSelector(getSelectedNetworkRequest);
  const selectedNetworkIndex = useAppSelector(getSelectedNetworkIndex);
  const appDetails = useAppSelector(getAppDetails);
  const dispatch = useAppDispatch();

  useEffect(() => {
    let responseMatches: { type: 'regex' | 'contains'; value: string }[] = [];
    let responseRedactions: {
      regex?: string;
      jsonPath?: string;
      xPath?: string;
    }[] = [];
    selectedInstances.map((e) => {
      let str = e.responseSelection.responseMatch.replace(
        `{{${e.variableName}}}`,
        `(?<${e.variableName}>.*?)`
      );
      responseMatches.push({
        type: 'regex',
        value: str,
      });
      responseRedactions.push({
        jsonPath: e.responseSelection.jsonPath,
      });
    });
    dispatch(
      updateAppDetails({
        zkfetchData: {
          url: selectedNetworkRequest[selectedNetworkIndex]?.url,
          options: {
            headers: selectedNetworkRequest[selectedNetworkIndex]?.publicHeaders,
            method: 'GET',
          },
          secretOptions: {
            headers: selectedNetworkRequest[selectedNetworkIndex]?.privateHeaders,
            responseMatches,
            responseRedactions,
          },
        },
      })
    );
  }, []);
  return appDetails?.zkfetchData ? (
    <>
      <IntegrationDetails />
    </>
  ) : (
    <></>
  );
};
export default ZkfetchFinlize;
